import React, { FC } from 'react';

import Menu from '../Sidebar/Menu';

import css from './style.module.scss';

interface IProps {
  onMenuClick?: () => void;
}

const MobileHeader: FC<IProps> = ({ onMenuClick }) => {
  return (
    <div className={css.mobileMenu}>
      <Menu onMenuClick={onMenuClick} />
    </div>
  )
}

export default MobileHeader;
